if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    var slideCount = $(".gallery__list").length;
    if (slideCount <= 4) {
        $(".gallery__list").children().clone(true, true).appendTo(".gallery__list");
    }


    $('.sym-slides').slick({
        accessibility: true,
    });

    $( '.slider-slick' ).each( function() {
      $( this ).slick( {
          fade: true,
          adaptiveHeight:false ,
          appendArrows: $(this).parents('.slider').find('.arrows-slider')
      } );
  } );

    //data-slick='{"fade":true , "arrows":true, "dots":false ,"adaptiveHeight":false , "appendArrows":".arrows-slider"}'
    var slider = $('.sym-slides.slider');
    $('.sym-slides.slider .slick-prev').on('click', function() {
      $(slider).slick('slickPrev');
    });
    $('.sym-slides.slider .slick-next').on('click', function() {
      $(slider).slick('slickNext');
    });

    $('.gallery__list').slick({
        fade: false,
        infinite:true,
        speed:true,
        adaptiveHeight:false,
        arrows:true,
        dots:false,
        slidesToShow:4,
        slidesToScroll:2,
        initialSlide:4,
        responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 900,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
            },
            {
              breakpoint: 668,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }     
          ]
    });

    //data-slick='{"fade":false,"variableWidth":false,  "infinite":true, "speed":1000, "adaptiveHeight":false, "arrows":true, "dots":false , "slidesToShow":4,"slidesToScroll": 2 , "initialSlide": 4 }'

    // $('.gallery__list').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    //     var CurrentSlideDom=$(slick.$slides.get(currentSlide));
    //     var NextSlideDom=$(slick.$slides.get(nextSlide));
    //     var FirstSlideDom=$(slick.$slides.get(currentSlide-1));
    //     var LastSlideDom=$(slick.$slides.get(nextSlide+1));
    //     console.log('before' , CurrentSlideDom);
    //     console.log('before' , NextSlideDom);
    //     console.log('before' , FirstSlideDom);
    //     console.log('before' , LastSlideDom);
    //     CurrentSlideDom.addClass('spacing-current');
    //     NextSlideDom.addClass('spacing-next')
    //     FirstSlideDom.removeClass('spacing-current');
    //     LastSlideDom.removeClass('spacing-current')
    //     FirstSlideDom.removeClass('spacing-next');
    //     LastSlideDom.removeClass('spacing-next')
    //   });

    if(document.getElementById('sparfp-form')){
      let buttonForm = document.querySelector('.js-readmore');
      let form = document.getElementById('sparfp-form');
      let firstText = buttonForm.textContent;

      buttonForm.addEventListener("click", () =>{
        if( form.classList.contains("is-active")){
          form.classList.remove("is-active");
          buttonForm.textContent = firstText;

        }else{
          form.classList.add("is-active");
          buttonForm.textContent='close'
        }
      });
      
    }

    // Show from URL
    document.addEventListener('DOMContentLoaded', () => {
      let location = window.location.href.split('#')[1];
      if (location && document.querySelector(`[href="#${location}"]`))
        document.querySelector(`[href="#${location}"]`).click();
    })

    // document.querySelectorAll('.js-readmore').forEach(item => {
    //   let isToggled = false;
    //   item.addEventListener('click', function() {
    //  if (isToggled) {
    //  this.classList.remove("toggle-class");
    //   } else {
    //  this.classList.add("toggle-class");
    //   }
    //   isToggled = !isToggled;
     
    //   if (this.classList.contains("toggle-class")) { 
    //     $(this).html('read less'); 
    //     $(this).parent().find('.short').slideUp(); 
    //     $(this).parent().find('.full').slideDown(); 
    //   } else { 
    //     $(this).html('read more'); 
    //     $(this).parent().find('.short').slideDown(); 
    //     $(this).parent().find('.full').slideUp(); 
    //   } 
    //   }) 
    // });
    if(document.getElementById("fsCountdown")){
      const fsCountdown = new Date(document.getElementById('fsCountdown').getAttribute('data-time'));
        //countdown
        let fsDays = 0;
        let fsHours = 0;
        let fsMinutes = 0;
        let fsSeconds = 0;
        tick();
        let fsTimer = setInterval(tick.bind(this), 1000);
     
      function updateRemaining(fsDistance) {

        console.log( (fsDistance % (1000 * 60 * 60 * 24)) );

        fsDays = Math.floor(fsDistance / (1000 * 60 * 60 * 24));
        fsHours = Math.floor((fsDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + 5;
        fsMinutes = Math.floor((fsDistance % (1000 * 60 * 60)) / (1000 * 60)) - 1;
        fsSeconds = Math.floor((fsDistance % (1000 * 60)) / 1000);

        document.getElementById('fsDays').innerHTML = fsDays;
        document.getElementById('fsHours').innerHTML = fsHours;
        document.getElementById('fsMinutes').innerHTML = fsMinutes;
        document.getElementById('fsSeconds').innerHTML = fsSeconds;
      }
      function tick() {
        const currentTime = new Date();
        const fsDistance = Math.max(fsCountdown - currentTime, 0);
        updateRemaining(fsDistance);

        if (fsDistance === 0) {
          clearInterval(fsTimer);
        }
      };
    }

    /** ADA Keyboard Navigation Functionality **/

    document.addEventListener('DOMContentLoaded', function(){
    const bookingButton = document.querySelector('.btn-booking');
    const bookingCloseBtn = document.querySelector('.js-booking-close');

    if (bookingButton) {
      bookingButton.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          document.querySelector('.booking-block').classList.toggle('open');
          if (bookingCloseBtn) bookingCloseBtn.focus();
        }
      }); 
    }

    if (bookingCloseBtn) {
      bookingCloseBtn.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          document.querySelector('.booking-block').classList.remove('open');
          const primaryNav1 = document.querySelector('.primary-nav-1 a');
          if (primaryNav1) {
            setTimeout(() => {
              primaryNav1.focus();
            }, 100);
          }
        }
      });
    }
  });
})();